import React from 'react'
import { IconButton } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp'
import { Card, Text } from '@tremor/react'

const data = [
  {
    label: 'Roll de pollo con · 20% off Promo',
    value: 40,
    color: '#CEDB9C',
  },
  {
    label: '20% off de bienvenida · Reward de uso único',
    value: 88,
    color: '#F49B5A',
  },
  {
    label: 'Copa de vino de regalo · Beneficio',
    value: 60,
    color: '#EAB83A',
  },
]

const montserratStyle = { fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }

const downloadCSV = () => {
  const csvRows = [['Canje', 'Usos'], ...data.map(row => [row.label, row.value])]
  const csvContent = csvRows.map(e => e.join(',')).join('\n')
  const blob = new Blob([csvContent], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = 'top3_canjes.csv'
  a.click()
  URL.revokeObjectURL(url)
}

export const Top3Redemptions = () => (
  <Card className="p-8">
    <div className="flex flex-row justify-between items-start mb-2">
      <Text className="text-lg font-bold" style={montserratStyle}>
        Top 3 canjes
      </Text>
      <div className="flex items-center gap-4">
        <Text className="text-xs font-bold" style={montserratStyle}>
          USOS
        </Text>
        <IconButton className="ml-2" aria-label="download" onClick={downloadCSV}>
          <GetAppIcon />
        </IconButton>
      </div>
    </div>
    <div className="flex flex-col gap-4 mt-6">
      {data.map(item => (
        <div key={item.label} className="flex items-center w-full">
          <div
            style={{
              flex: 1,
              height: 36,
              background: item.color,
              borderRadius: 6,
              marginRight: 24,
              display: 'flex',
              alignItems: 'center',
              paddingLeft: 16,
              color: '#1E1E1E',
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 500,
              fontSize: 16,
            }}
          >
            {item.label}
          </div>
          <span className="text-xl font-extrabold ml-2" style={montserratStyle}>
            {item.value}
          </span>
        </div>
      ))}
    </div>
  </Card>
)
